import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './FootPrintApiManager.types'

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_footprint_generic_json_invoice_export_dataService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { invoice_id?: number }): Promise<{ DatexInvoiceInfo?: $types.FootPrintApiManager.DatexInvoiceInfo, invoice_id?: number, messages?: any[] }> 
  {
    let url = `${environment.backendUrl}api/FootPrintApiManager/functions/footprint_generic_json_invoice_export_data`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

